module.exports = __webpack_public_path__ + "static/img/appicon.e27f27af.svg";